export default "__VITE_ASSET__DHeZ8ZFt__"